export enum SOCIAL_EMERGENCE_CONNECTION_TYPE {
    personal = 'personal',
    indirect = 'indirect',
    parasocial = 'parasocial',
    stereotype = 'stereotype',
    stranger = 'stranger',
}
